export default "__VITE_ASSET__5FECEKQ5__"